import {
  CREATE_PITCH_FAIL,
  CREATE_PITCH_PENDING,
  CREATE_PITCH_SUCCESS,
  UPDATE_PITCH_FAIL,
  UPDATE_PITCH_PENDING,
  UPDATE_PITCH_SUCCESS,
  GET_PITCH_FAIL,
  GET_PITCH_SUCCESS,
  GET_PITCH_PENDING,
  GET_NEXT_PITCH_SUCCESS,
  GET_TEMPLATE_PITCH,
  CREATE_TEMPLATE_PITCH,
  UPDATE_TEMPLATE_PITCH,
  GET_PITCH_QUALITY_METRICS,
} from '../actions/pitchActions';


const initialState = {
  pitch: {
    loading: false,
    loaded: true,
    id: null,
    name: null,
    subject: null,
    body: null,
    is_template: null,
  },
  pitches: {
    results: [],
    nextTemplateUrl: null,
  },
  pitchQualityMetrics: {
    spam_words: [],
    subject_length: null,
    body_word_count: null,
    question_count: null,
    spam_word_count: null,
    personalization: null,
  },
};

export const pitchReducer = (state = initialState.pitch, action) => {
  switch (action.type) {
    case CREATE_PITCH_PENDING:
      return {
        loading: true,
        loaded: false,
      };
    case CREATE_PITCH_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case CREATE_PITCH_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_PITCH_PENDING:
      return {
        loading: true,
        loaded: false,
      };
    case UPDATE_PITCH_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_PITCH_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    default:
      return state;
  }
};


export const pitchesReducer = (state = initialState.pitches, action) => {
  switch (action.type) {
    case GET_PITCH_PENDING:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case GET_PITCH_FAIL:
      return {
        loading: false,
        loaded: true,
        results: [],
        ...action.payload,
      };
    case GET_PITCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        nextTemplateUrl: action.payload.next,
        results: action.payload.results,
      };
    case GET_NEXT_PITCH_SUCCESS:
      return {
        ...state,
        nextTemplateUrl: action.payload.next,
        // eslint-disable-next-line max-len
        results: [...state.results, ...action.payload.results],
      };
    default:
      return state;
  }
};

export const templatePitchReducer = (state = initialState.pitches, action) => {
  switch (action.type) {
    case CREATE_TEMPLATE_PITCH.pending:
      return {
        loading: true,
        loaded: false,
      };
    case CREATE_TEMPLATE_PITCH.error:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case CREATE_TEMPLATE_PITCH.success:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_TEMPLATE_PITCH.pending:
      return {
        loading: true,
        loaded: false,
      };
    case UPDATE_TEMPLATE_PITCH.error:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case UPDATE_TEMPLATE_PITCH.success:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    default:
      return state;
  }
};

export const templatePitchesReducer = (state = initialState.pitches, action) => {
  switch (action.type) {
    case GET_TEMPLATE_PITCH.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case GET_TEMPLATE_PITCH.error:
      return {
        loading: false,
        loaded: true,
        results: [],
        ...action.payload,
      };
    case GET_TEMPLATE_PITCH.success:
      return {
        ...state,
        loading: false,
        loaded: true,
        results: action.payload,
      };
    default:
      return state;
  }
};

export const pitchQualityMetricsReducer = (state = initialState.pitchQualityMetrics, action) => {
  switch (action.type) {
    case GET_PITCH_QUALITY_METRICS.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case GET_PITCH_QUALITY_METRICS.error:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case GET_PITCH_QUALITY_METRICS.success:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    default:
      return state;
  }
};
